import { render } from "./LineChart.vue?vue&type=template&id=3c87acf0&scoped=true"
import script from "./LineChart.vue?vue&type=script&lang=ts"
export * from "./LineChart.vue?vue&type=script&lang=ts"

import "./LineChart.vue?vue&type=style&index=0&id=3c87acf0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c87acf0"

export default script